<template>
  <div class="tx-section-page">
    <div class="banner" @click.self="changeHandle">交易列表</div>
    <div class="content-wrapper">
      <div class="content-one">
        <div class="tx-line-charts-box-inner"></div>
      </div>
      <div class="content-two">
        <el-input placeholder="请输入完整的数据hash" v-model="keyword" clearable
        @clear="fetchTransList">
          <template slot="prepend">搜交易</template>
          <el-button slot="append" icon="el-icon-search" @click="fetchTransByHash"></el-button>
        </el-input>
        <el-table
          class="data-table"
          height="100%"
          :data="transList" align="left">
          <el-table-column
            width="100"
            prop="blockNumber_1"
            label="区块号">
          </el-table-column>
          <el-table-column
            width="150"
            prop="channelName"
            label="链名称">
          </el-table-column>
          <el-table-column
            width="100"
            prop="transactionIndex_1"
            label="数据ID">
          </el-table-column>
          <el-table-column
            prop="hash"
            label="数据Hash">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.hash }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.hash }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="from"
            label="发送方账户">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.from }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.from }}</div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="input"
            label="接收方账户">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                {{ scope.row.input }}
                <div slot="reference" class="hash-wrapper">
                  {{ scope.row.input }}</div>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
let echarts = require('echarts')
export default {
  props: ['totalNm'],
  data() {
    return {
      currentChart: 'lineChart',
      barCharts: '',
      lineCharts: '',
      txChartTwo: '',
      keyword: '',
      transList: [],
      lineOptionInit: {
        title: {
          left: 'center',
          text: '一个月数据上链统计',
          textStyle: {
            fontSize: '14',
            color: '#000'
          }
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          // position: function (pt) {
          //   return [pt[0], '10%'];
          // }
        },
        xAxis : {
          type : 'category',
          data: [],
          axisTick:{lineStyle: {color: '#2EBE4C'}},
          axisLabel:{color: '#2EBE4C'},
        },
        yAxis:{
          type : 'value',
          axisLine: {show: false},
          axisTick:{lineStyle: {color: '#2EBE4C',width: 2}},
          axisLabel: {color: '#2EBE4C', formatter: '{value} 笔'}
        },
        grid: {
          left: 50,
          right: 0,
          top: '20%',
          bottom: '8%',
        },
        series: [
          {
            name:'数据量',
            type:'line',
            stack: '总量',
            // smooth: true,
            // smoothMonotone: 'x',
            interval: 1,
            min: 0,
            max: function(value) {return value.max + 3},
            splitNumber: 5,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#0075FF'
              }, {
                offset: 0.45,
                color: '#00A3FF'
              }, {
                offset: 1,
                color: '#2FFFB4'
              }])
            },
            lineStyle: {width: 4},
            // areaStyle: {
            //   color: {
            //     type: 'linear',
            //     x: 0,
            //     y: 1,
            //     x2: 0,
            //     y2: 0,
            //     colorStops: [{
            //         offset: 0.03, color: 'rgba(0,0,0,0.5)' // 0% 处的颜色
            //     }, {
            //         offset: 1, color: '#e6a23c' // 100% 处的颜色
            //     }],
            //   }
            // },
            // lineStyle: {width: 4},
            data:[]
          },
        ]
      },
    }
  },
  components: {},
  computed: {
    lineOption () {
      return this.lineOptionInit
    }
  },
  mounted() {
    this.initPage()
    this.fetchTransList()
    this.fetchLineChartData()
  },
  methods: {
    initPage() {
      let _this = this
      this.lineCharts = echarts.init(document.querySelector('.tx-line-charts-box-inner'))
      window.addEventListener('resize', () => {
        _this.lineCharts.resize()
      })
      this.renderLineChart()
    },
    renderLineChart() {
      this.lineCharts.setOption(this.lineOption)
      this.lineCharts.resize()
    },
    changeHandle() {
      let pageRoot = document.querySelector('.tx-section-page')
      this.$emit('callback', pageRoot)
    },
    generateData(count) {
      let baseValue = Math.random() * 1000;
      let time = +new Date(2011, 0, 1);
      let smallBaseValue;

      function next(idx) {
          smallBaseValue = idx % 30 === 0
              ? Math.random() * 700
              : (smallBaseValue + Math.random() * 500 - 250);
          baseValue += Math.random() * 20 - 10;
          return Math.max(
              0,
              Math.round(baseValue + smallBaseValue) + 3000
          );
      }

      let categoryData = [];
      let valueData = [];

      for (let i = 0; i < count; i++) {
          categoryData.push(echarts.format.formatTime('yyyy-MM-dd\nhh:mm:ss', time));
          valueData.push(next(i).toFixed(2));
          time += 1000;
      }

      return {
          categoryData: categoryData,
          valueData: valueData
      };
    },
    fetchBlockHeight () {
      return this.$http({"id":83, "method":"eth_blockNumber"})
    },
    fetchTransDetail (blockNumber) {
      return this.$http({
        'id': 1,
        params: [blockNumber, true],
        "method":"eth_getBlockTransactionCountByNumber"
      })
    },
    // async fetchTransList () {
    //   let currentBlock = await this.fetchBlockHeight()

    //   let number = parseInt(currentBlock, 16)

    //   for (let index = 0; index < 3; index++) {
    //     let number0x = `0x${number.toString(16)}`
    //     let blockItem = await this.fetchTransDetail(number0x)
    //     blockItem.number_1 = parseInt(blockItem.number, 16)
    //     blockItem.channelName = channelName[0].name
    //     number--
    //     this.blockList.push(blockItem)
    //   }
    // }
    fetchChannel () {
      return this.$http({
        id: 1,
        method: 'net_channelInfo'
      })
    },
    async fetchLineChartData () {
      let time = new Date()
      time.setMonth(time.getMonth() - 1)
      let utcTime = (Math.round(time.getTime()/1000)).toString()
      let lineData = await this.$http({
        "method":"eth_getStatistics",
        "params":[utcTime, 'tx'],
        "id":1
      })

      for (const key in lineData) {
        this.lineOptionInit.series[0]['data'].push(lineData[key])
        // console.log(new Date(Number(key)))
        let date = echarts.format.formatTime('yyyy-MM-dd', Number(key)*1000)
        this.lineOptionInit.xAxis.data.push(date)
      }

      this.renderLineChart()

      // console.log(this.lineOptionInit.series[0]['data'])

    },
    async fetchTransList () {
      let dataList = await this.$http({
        "method":"eth_getTransactions",
        "params":['0', '8'],
        "id":1})

      dataList.map(item => {
        item.blockNumber_1 = parseInt(item.blockNumber, 16)
        item.transactionIndex_1 = parseInt(item.transactionIndex, 16)
        item.channelName = document.title
      })
      this.transList = dataList
    },
    themeHandle(theme) {
      let color = theme === 'light' ? '#2EBE4C' : '#fff'
      let titleColor = theme === 'light' ? '#000' : '#fff'
      this.lineOptionInit.title.textStyle.color = titleColor
      this.lineOptionInit.xAxis.axisTick.lineStyle.color = color
      this.lineOptionInit.yAxis.axisTick.lineStyle.color = color
      this.lineOptionInit.xAxis.axisLabel.color = color
      this.lineOptionInit.yAxis.axisLabel.color = color
      this.renderLineChart()
    },
    async fetchTransByHash() {
      if (!this.keyword) return
      let transDetail = await this.$http({
       "method":"eth_getTransactionByHash",
        "params":[this.keyword],
        "id":1})
      let channelName = await this.fetchChannel()
      transDetail.blockNumber_1 = parseInt(transDetail.blockNumber, 16)
      transDetail.transactionIndex_1 = parseInt(transDetail.transactionIndex, 16)
      transDetail.channelName = channelName[0].name
      this.transList = [transDetail]
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/init-css.scss';

$area-radius: 25px;
$area-padding-V: .2rem;
$area-padding-H: .4rem;
$area-margin: .2rem;

.tx-section-page {
  position: relative;
  .banner {
    position: absolute;
    // color: #fff;
    font-weight: bold;
    z-index: 1000;
    text-align: left;
  }

  .el-table {
    background: none;
  }

  .content-wrapper {
    .content-one {
      display: flex;
      flex-direction: column;
      position: relative;

      .tx-line-charts-box-inner {
        height: 100%;
      }
    }
  }

  .el-table__body {
    tr:hover>td{
      background-color: transparent!important;
    }
  }

  .el-button+.el-button {
    margin: 0;
  }

  //--------------------置中样式
  &.section-center {
    .banner {
      font-size: .25rem;
      // position: absolute;
      // top: .2rem;
      // left: .4rem;
    }
    .content-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      .content-one {
        height: 50%;
      }

      .content-two {
        height: 50%;
        background: #fff;
        border-radius: 10px;
        padding: 5px;
        text-align: left;
        .el-input-group {
          margin: 10px;
          width: 60%;
          text-align: left;
        }
        .chart-box-two {
          height: 100%;
        }

        .table-button-box {
          display: flex;
          justify-content: flex-end;
          margin-top: .15rem;
          .el-button {
            width: 1.5rem;
            color: #fff;
            border: none;
            background: #14142e;
            &:last-child{
              margin-left: .2rem
            }
          }
        }
      }

      .content-four {
        font-size: .25rem;
        text-align: right;
        .text {
          display: inline-block;
          margin-left: .2rem;
          font-size: .3rem;
          font-weight: bold;
        }
      }
    }

    .content-three {
      display: none;
      margin-left: $area-margin;
      flex: 1;
      .table-header {
        display: flex;
        justify-content: space-between;
        padding: .2rem;
        .title {
        font-size: .15rem;
        }
        .button-box {
          display: flex;
          flex-direction: column;
          .el-button {
            margin-bottom: .1rem;
          }
        }
      }
    }

  }

  //-------------------------左上样式
  &.section-left {
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .banner {
      font-size: .25rem;
      position: absolute;
      top: .2rem;
      left: .4rem;
    }

    .content-wrapper {
      height: 50%;
      .content-one {
        height: 100%;
      }

      .content-three, .content-four {
        display: none;
      }
    }

    .content-two {
      height: 100%;
      position: relative;
      padding-top: .2rem;
      box-sizing: border-box;

      .el-input-group {
        display: none;
      }
      .table-header .title{
        text-align: left;
        color: #fff;
        font-weight: bold;
        font-size: .25rem;
      }

      .el-table {
        &::before {
          display: none;
        }
        &.el-table--scrollable-x .el-table__body-wrapper {
          height: 80%;
          overflow: auto;
        }

        td, th {
          padding: 0.08rem 0;
          border-bottom: none;
        }
        .el-table__header  th.is-leaf{
          font-size: .12rem;
          height: .2rem;
          padding: .02rem 0;
        }
      }



      .button {
        position: absolute;
        bottom: 5%;
        right: 0;
        padding: .05rem .1rem;
        color: $font-color;
        border: none;
        background: #58588c;
      }
    }
  }


  //-------------------左下右下样式
  &.section-bottom-left, &.section-bottom-right {
    display: flex;
    border-radius: $area-radius;
    background: $area-background;
    padding: .2rem .4rem;
    box-sizing: border-box;
    .banner {
      font-size: .25rem;
      top: .2rem;
      left: .4rem;
    }
    .content-wrapper{
      flex: 1;
      .content-one {
        height: 100%;
      }
    }

    .content-three, .content-two, .content-four  {
      display: none;
    }
  }


}

</style>

<style lang="scss">
@import '@/assets/css/init-css.scss';

.tx-section-page {
  .content-one{
    .button-box-chart {
      .el-button {
        padding: .05rem;
        &:last-child{
          margin-left: .05rem;
        }
      }
    }
  }

  .el-table th, .el-table tr {
    background: none;
  }

  .el-table_4_column_17 {
    color: $theme-font-color;
  }
}
</style>
